import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import { AuthProvider } from './context/AuthContext';
import { AppDataProvider } from './context/AppDataContext';
import { SyncProvider } from './context/SyncContext';
import { ProductsProvider } from './context/ProductsContext';
import { CartProvider } from './context/CartContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import { LanguageProvider } from './i18n/index.jsx';
import { ThemeProvider } from './context/ThemeContext';

createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <BrowserRouter>
      <LanguageProvider>
        <ThemeProvider>
        <AuthProvider>
          <AppDataProvider>
            <SyncProvider>
              <ProductsProvider>
                <CartProvider>
                  <App />
                </CartProvider>
              </ProductsProvider>
            </SyncProvider>
          </AppDataProvider>
        </AuthProvider>
        </ThemeProvider>
      </LanguageProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
